const state = {}
const getters = {}
const mutations = {}
const actions = {
  reload_room({ commit, state }) {
    this.$socket.emit('reload_room', {
      group: 'owljourney_chat'
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
